<template>
  <section class="project-about">
	<v-container>
	  <v-row class="flex-md-row-reverse align-center">
		<v-col class="d-sm-none">
		  <h2 class="mb-10">О проекте</h2>
		</v-col>
		<v-col class="project__line" cols="12" md="7" lg="7">
		  <img
			  class="d-flex project-about__imgs"
			  @mouseup="handleMouseUp"
			  @mousedown="handleMouseDown"
			  @mousemove="handleMouseMove"
			  @mouseleave="handleMouseLeave"
			  @touchend="handleTouchEnd"
			  @touchstart="handleTouchStart"
			  @touchmove="handleTouchMove"
			  :src="carousel.currentPath"
		  />
		  <div class="d-flex justify-space-between project-about__btns">
			<button @click="prevImg">
			  <svg
				  width="16"
				  height="12"
				  viewBox="0 0 16 12"
				  fill="none"
				  xmlns="http://www.w3.org/2000/svg"
			  >
				<path
					d="M16 6L6 0.226497V11.7735L16 6ZM0 7H7V5H0V7Z"
					fill="#252E34"
				/>
			  </svg>
			</button>
			<svg
				width="44"
				height="36"
				viewBox="0 0 44 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
			  <path
				  d="M12.9997 35.3332L10.6663 32.9998L13.583 29.9998C10.0275 29.5276 7.0969 28.5554 4.79134 27.0832C2.48579 25.6109 1.33301 23.9165 1.33301 21.9998C1.33301 19.6943 2.93745 17.7287 6.14634 16.1032C9.35412 14.4787 13.3052 13.6665 17.9997 13.6665C22.6941 13.6665 26.6458 14.4787 29.8547 16.1032C33.0625 17.7287 34.6663 19.6943 34.6663 21.9998C34.6663 23.7221 33.7425 25.2637 31.8947 26.6248C30.048 27.9859 27.6386 28.9998 24.6663 29.6665V26.2498C26.8052 25.6943 28.4508 25.0065 29.603 24.1865C30.7563 23.3676 31.333 22.6387 31.333 21.9998C31.333 21.1109 30.1458 20.0554 27.7713 18.8332C25.3958 17.6109 22.1386 16.9998 17.9997 16.9998C13.8608 16.9998 10.6041 17.6109 8.22967 18.8332C5.85412 20.0554 4.66634 21.1109 4.66634 21.9998C4.66634 22.6665 5.37467 23.4654 6.79134 24.3965C8.20801 25.3265 10.2219 26.0276 12.833 26.4998L10.6663 24.3332L12.9997 21.9998L19.6663 28.6665L12.9997 35.3332Z"
				  fill="#C1CFD8"
			  />
			  <path
				  opacity="0.7"
				  d="M8.76 7.98C8.76 7.27333 8.44667 6.68 7.82 6.2C7.20667 5.70667 6.42667 5.46 5.48 5.46C4.73333 5.46 4.07333 5.62667 3.5 5.96C2.92667 6.28 2.51333 6.70667 2.26 7.24L1.22 6.74C1.56667 6.00667 2.12 5.42667 2.88 5C3.65333 4.56 4.52 4.34 5.48 4.34C6.74667 4.34 7.80667 4.68667 8.66 5.38C9.52667 6.08667 9.96 6.94667 9.96 7.96C9.96 8.62667 9.74667 9.24 9.32 9.8C8.90667 10.3467 8.35333 10.76 7.66 11.04C8.46 11.32 9.09333 11.76 9.56 12.36C10.0267 12.96 10.26 13.6333 10.26 14.38C10.26 15.4467 9.80667 16.3533 8.9 17.1C8.00667 17.82 6.87333 18.18 5.5 18.18C4.46 18.18 3.54 17.96 2.74 17.52C1.94 17.08 1.36667 16.48 1.02 15.72L2.14 15.28C2.39333 15.8133 2.82 16.24 3.42 16.56C4.02 16.88 4.71333 17.04 5.5 17.04C6.52667 17.04 7.37333 16.78 8.04 16.26C8.72 15.74 9.06 15.0933 9.06 14.32C9.06 13.56 8.72667 12.9267 8.06 12.42C7.39333 11.9133 6.57333 11.66 5.6 11.66H4.6V10.56H5.34C6.31333 10.56 7.12667 10.3133 7.78 9.82C8.43333 9.32667 8.76 8.71333 8.76 7.98ZM22.0263 6.56L20.9663 7.12C20.6463 6.6 20.1996 6.19333 19.6263 5.9C19.0529 5.60667 18.4196 5.46 17.7263 5.46C16.6463 5.46 15.7396 5.80667 15.0063 6.5C14.2729 7.18 13.9062 8.02667 13.9062 9.04V11.28C14.2663 10.72 14.7729 10.28 15.4263 9.96C16.0796 9.62667 16.7996 9.46 17.5863 9.46C18.9463 9.46 20.0863 9.88 21.0063 10.72C21.9396 11.5333 22.4063 12.5667 22.4063 13.82C22.4063 15.0467 21.9396 16.08 21.0063 16.92C20.0863 17.76 18.9463 18.18 17.5863 18.18C16.2129 18.18 15.0596 17.76 14.1263 16.92C13.2063 16.08 12.7463 15.0467 12.7463 13.82V9.06C12.7463 7.71333 13.2263 6.59333 14.1863 5.7C15.1596 4.79333 16.3529 4.34 17.7663 4.34C18.6729 4.34 19.4996 4.54 20.2463 4.94C20.9929 5.32667 21.5863 5.86667 22.0263 6.56ZM17.5863 17.04C18.5996 17.04 19.4529 16.7333 20.1463 16.12C20.8529 15.4933 21.2063 14.7333 21.2063 13.84C21.2063 12.9067 20.8596 12.1333 20.1663 11.52C19.4596 10.8933 18.5996 10.58 17.5863 10.58C16.5596 10.58 15.6929 10.8933 14.9863 11.52C14.2929 12.1333 13.9463 12.8933 13.9463 13.8C13.9463 14.72 14.2929 15.4867 14.9863 16.1C15.6929 16.7267 16.5596 17.04 17.5863 17.04ZM24.7189 13.44V9.06C24.7189 7.71333 25.1989 6.59333 26.1589 5.7C27.1322 4.79333 28.3256 4.34 29.7389 4.34C31.1522 4.34 32.3322 4.79333 33.2789 5.7C34.2389 6.59333 34.7189 7.71333 34.7189 9.06V13.44C34.7189 14.8 34.2389 15.9267 33.2789 16.82C32.3322 17.7267 31.1522 18.18 29.7389 18.18C28.3256 18.18 27.1322 17.7267 26.1589 16.82C25.1989 15.9267 24.7189 14.8 24.7189 13.44ZM29.7389 5.46C28.6322 5.46 27.7122 5.80667 26.9789 6.5C26.2456 7.18 25.8789 8.02667 25.8789 9.04V13.44C25.8789 14.4533 26.2456 15.3067 26.9789 16C27.7122 16.6933 28.6322 17.04 29.7389 17.04C30.8189 17.04 31.7256 16.6933 32.4589 16C33.2056 15.2933 33.5789 14.44 33.5789 13.44V9.04C33.5789 8.02667 33.2056 7.18 32.4589 6.5C31.7256 5.80667 30.8189 5.46 29.7389 5.46ZM39.8347 3.32C40.688 3.32 41.3947 3.60667 41.9547 4.18C42.5147 4.74 42.7947 5.44 42.7947 6.28C42.7947 7.10667 42.5147 7.81333 41.9547 8.4C41.3947 8.96 40.688 9.24 39.8347 9.24C39.0214 9.24 38.3214 8.96 37.7347 8.4C37.1747 7.81333 36.8947 7.10667 36.8947 6.28C36.8947 5.44 37.1747 4.74 37.7347 4.18C38.308 3.60667 39.008 3.32 39.8347 3.32ZM39.8347 8.18C40.3814 8.18 40.8347 8 41.1947 7.64C41.5547 7.26667 41.7347 6.81333 41.7347 6.28C41.7347 5.74667 41.5547 5.3 41.1947 4.94C40.8347 4.56667 40.3814 4.38 39.8347 4.38C39.3014 4.38 38.8547 4.56667 38.4947 4.94C38.1347 5.3 37.9547 5.74667 37.9547 6.28C37.9547 6.81333 38.1347 7.26667 38.4947 7.64C38.8547 8 39.3014 8.18 39.8347 8.18Z"
				  fill="#252E34"
			  />
			</svg>
			<button @click="nextImg">
			  <svg
				  width="16"
				  height="12"
				  viewBox="0 0 16 12"
				  fill="none"
				  xmlns="http://www.w3.org/2000/svg"
			  >
				<path
					d="M16 6L6 0.226497V11.7735L16 6ZM0 7H7V5H0V7Z"
					fill="#252E34"
				/>
			  </svg>
			</button>
		  </div>
		</v-col>
		<v-col cols="12" md="5" lg="5">
		  <div class="project-about__content">
			<div class="project-about__back"></div>
			<h2 class="d-none d-sm-block mb-5 mb-md-11">О проекте</h2>
			<p class="size-sm">
			  Serebro by Avenue-Apart – премиальный Комплекс в самом сердце Приморского района Санкт-Петербурга. Если вы
			  подбираете недвижимость недалеко от центра города с развитой инфраструктурой, в окружении зелени и чистого
			  воздуха, новый проект по адресу Серебристый бульвар, 18а станет идеальным решением
			</p>
			<router-link :to="{ name: 'flats' }">
			  <btn>Выбрать апартаменты</btn>
			</router-link>

			<div class="project-about__border"></div>
		  </div>
		</v-col>
	  </v-row>
	</v-container>
  </section>
</template>

<style lang="scss">
.project {
  /*& .container {
		max-width: unset;
		@include up($md) {
			max-width: 1200px;
		}
		@include up($lg) {
			max-width: 1720px;
		}
	}*/

  &__line {
	position: relative;
	z-index: 1;
	@include up($md) {
	  margin-top: -150px;
	}

	&:before {
	  position: absolute;
	  content: "";
	  width: 90%;
	  height: 2px;
	  background: #c1cfd8;
	  opacity: 0.6;
	  left: 5%;
	  top: 70%;
	  z-index: -1;

	}
  }

  & .btn {
	background-color: transparent;
  }

  &-about {
	& .v-image {
	  max-width: 800px;
	  width: 100%;
	  margin: auto;
	  z-index: 1;
	}

	&__imgs {
	  max-width: 800px;
	  width: 100%;
	  margin: auto;
	  z-index: 1;
	}

	&__content {
	  position: relative;
	  z-index: 1;
	  padding: 28px 24px;
	  @include up($md) {
		//padding: 60px 48px 70px;
		padding: 28px 0 110px 76px;
		margin-top: 0;
	  }

	  p {
		margin-bottom: 48px;
		@include up($md) {
		  margin-bottom: 90px;
		}
	  }
	}

	&__border {
	  border: 1px solid $dark-grey;
	  border-radius: 0px 0px 0px 40px;
	  margin-top: 20px;
	  padding: 12px 2px 44px 40px;
	  position: absolute;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  z-index: -2;
	}

	&__btn {
	  line-height: 120%;
	  color: $black;
	  max-width: 207px;
	  margin-left: auto;
	  @include up($md) {
		max-width: 326px;
	  }
	}

	&__back {
	  position: absolute;
	  background-color: $light-grey;
	  background-image: url("@/assets/Project/project-about/back.jpeg");
	  background-size: cover;
	  border-radius: 0px 0px 0px 40px;
	  width: 100%;
	  height: 100%;
	  top: -16px;
	  left: 16px;
	  z-index: -1;
	  @include up($md) {
		top: -32px;
		left: 48px;
	  }
	}

	&__btns {
	  max-width: 444px;
	  margin: -50px auto 0;
	  z-index: 1;
	  position: relative;

	  button {
		width: 40px;
		height: 40px;

		&:first-child {
		  transform: rotate(180deg);
		}
	  }
	}
  }
}
</style>
<script>
import Btn from "@/components/btn";
import {computed} from "vue";


export default {
  components: {Btn},
  data: () => {
	return {
	  carousel: {
		current: 0,
		currentPath: null
	  },
	  mouse: {
		isMoving: false,
		savedPositionX: 0,
		currentPositionX: 0,
	  },
	  images: [
		require("@/assets/Project/project-about/360/01.png"),
		require("@/assets/Project/project-about/360/02.png"),
		require("@/assets/Project/project-about/360/03.png"),
		require("@/assets/Project/project-about/360/04.png"),
		require("@/assets/Project/project-about/360/05.png"),
		require("@/assets/Project/project-about/360/06.png"),
		require("@/assets/Project/project-about/360/07.png"),
		require("@/assets/Project/project-about/360/08.png"),
		require("@/assets/Project/project-about/360/09.png"),
		require("@/assets/Project/project-about/360/10.png"),
		require("@/assets/Project/project-about/360/11.png"),
		require("@/assets/Project/project-about/360/12.png"),
		require("@/assets/Project/project-about/360/13.png"),
		require("@/assets/Project/project-about/360/14.png"),
		require("@/assets/Project/project-about/360/15.png"),
		require("@/assets/Project/project-about/360/16.png"),
		require("@/assets/Project/project-about/360/17.png")
	  ],
	};
  },
  props: {

	imageClass: {
	  type: String,
	  default: null,
	},
	speed: {
	  type: Number,
	  default: 10,
	},
	reverse: {
	  type: Boolean,
	  default: false,
	},
	infinite: {
	  type: Boolean,
	  default: true,
	},
	disabled: {
	  type: Boolean,
	  default: false,
	},
	keepPosition: {
	  type: Boolean,
	  default: true,
	},
  },
  methods: {
	nextImg() {
	  //if (this.carousel.currentPath >= (this.carousel.currentPath.length - 1)) this.carousel.currentPath = 0;
	  //else this.carousel.currentPath += 1;
	  // console.log(this.imgIndex)


	  if (this.carousel.current < this.images.length) {
		this.carousel.current += 1;
		this.carousel.currentPath = this.images[this.carousel.current - 1];
	  } else if (this.infinite) {
		this.carousel.current = 0;
		this.carousel.currentPath = this.images[this.carousel.current];
	  }
	},
	prevImg() {
	  //if (this.imgIndex <= 0) this.imgIndex = (this.images.length - 1);
	  //else this.imgIndex -= 1;
	  // console.log(this.imgIndex)

	  if (this.carousel.current > 1) {
		this.carousel.current -= 1;
		this.carousel.currentPath = this.images[this.carousel.current - 1];
	  } else if (this.infinite) {
		this.carousel.current = this.images.length;
		this.carousel.currentPath = this.images[this.carousel.current - 1];
	  }
	},
	handleLoading() {
	  return ImagesLoader(this.images).then(() => {
		this.isLoaded = true;
	  });
	},
	handleMouseUp() {
	  this.mouse.isMoving = false;
	  this.$emit('stopping', {position: this.carousel.current});
	},
	handleMouseLeave() {
	  if (this.mouse.isMoving) {
		this.mouse.isMoving = false;
		this.$emit('stopping', {position: this.carousel.current});
	  }
	},
	handleMouseDown(event) {
	  if (!this.disabled) {
		this.mouse.savedPositionX = event.pageX;
		this.mouse.isMoving = true;
		this.$emit('starting', {position: this.carousel.current});
	  }
	},
	handleTouchStart(event) {
	  event.preventDefault();
	  if (!this.disabled) {
		this.mouse.savedPositionX = event.touches[0].pageX;
		this.mouse.isMoving = true;
		this.$emit('starting');
	  }
	},
	handleTouchEnd() {
	  this.mouse.isMoving = false;
	  this.$emit('stopping');
	},
	handleTouchMove(event) {
	  event.preventDefault();
	  this.handleMovement(event.touches[0].pageX);
	},
	handleMouseMove(event) {
	  this.handleMovement(event.pageX);
	},
	handleMovement(currentPosition) {
	  if (this.mouse.isMoving) {
		this.mouse.currentPositionX = currentPosition;
		const distance = this.mouse.currentPositionX - this.mouse.savedPositionX;
		if (Math.abs(distance) > this.speed) {
		  this.mouse.savedPositionX = this.mouse.currentPositionX;
		  if ((distance > 0 && !this.reverse) || (distance < 0 && this.reverse)) {
			this.slideToRight();
		  } else {
			this.slideToLeft();
		  }
		}
	  }
	},
	slideToRight() {
	  if (this.carousel.current < this.images.length) {
		this.carousel.current += 1;
		this.carousel.currentPath = this.images[this.carousel.current - 1];
	  } else if (this.infinite) {
		this.carousel.current = 0;
		this.carousel.currentPath = this.images[this.carousel.current];
	  }
	},
	slideToLeft() {
	  if (this.carousel.current > 1) {
		this.carousel.current -= 1;
		this.carousel.currentPath = this.images[this.carousel.current - 1];
	  } else if (this.infinite) {
		this.carousel.current = this.images.length;
		this.carousel.currentPath = this.images[this.carousel.current - 1];
	  }
	},
	slideTo(position) {
	  if (this.images[position]) {
		this.carousel.current = position;
		this.carousel.currentPath = this.images[position === 0 ? position : position - 1];
	  }
	},
  },
  created() {
	this.carousel.currentPath = this.images[this.carousel.current];
  },


};
</script>